import { Slot } from '@radix-ui/react-slot';
import type { ComponentPropsWithoutRef, PropsWithChildren } from 'react';

import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

export type MenuItemState = 'error' | 'warning' | 'success';

interface KebabMenuItemProps
  extends PropsWithChildren,
    Omit<ComponentPropsWithoutRef<'button'>, 'className'> {
  state?: MenuItemState;
  asChild?: boolean;
}

const kebabMenuItem = variants({
  base: cn(
    'flex',
    'px-md',
    'py-sm',
    'text-white',
    'gap-sm',
    'bg-level-02',
    'cursor-pointer',
    'w-full',
    'transition-colors',
    'duration-200',
    'hover:bg-level-03',
    'focus:bg-level-03',
    'focus:outline-none',
    'border-emphasis-default',
    'border-y-0',
    'border-x-px',
    'first-of-type:border-t-px',
    'first-of-type:rounded-t-xs',
    'last-of-type:rounded-b-xs',
    'last-of-type:border-b-px',
  ),
  variants: {
    state: {
      error: cn('text-error-default'),
      warning: cn('text-warning-default'),
      success: cn('text-success-default'),
    },
  },
});

export function KebabMenuItem({
  children,
  asChild,
  state,
  ...props
}: KebabMenuItemProps) {
  const Component = asChild ? Slot : 'button';

  return (
    <Component {...props} className={cn(kebabMenuItem({ state }))}>
      {children}
    </Component>
  );
}

KebabMenuItem.displayName = 'KebabMenuItem';
